/* Little Faith v3 (14.10.2026): Klick-Rueckmeldung, Ladebalken, Lieferzeitleiste */
(function () {
  var CARD = 'product-card, .lf-card, .lf-look__card, .lf-also, .resource-card';

  /* ---------- 1 · Klick-Rueckmeldung ---------- */
  function cardOf(t) { return t && t.closest ? t.closest(CARD) : null; }
  var pressed = null;
  function release() { if (pressed) { pressed.classList.remove('lf-press'); pressed = null; } }
  document.addEventListener('pointerdown', function (e) {
    if (e.button && e.button !== 0) return;
    var c = cardOf(e.target);
    if (!c) return;
    // Farbpunkte, Schnellkauf usw. nicht als Produkt-Klick werten
    if (e.target.closest('button, input, label, select, .swatch, .variant-option, quick-add-component')) return;
    release();
    pressed = c;
    c.classList.add('lf-press');
  }, { passive: true });
  ['pointerup', 'pointercancel', 'dragstart'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(release, 140); }, { passive: true });
  });
  document.addEventListener('scroll', release, { passive: true, capture: true });

  /* ---------- 2 · Ladebalken beim Seitenwechsel ---------- */
  var bar;
  function showBar() {
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'lf-navbar';
      bar.setAttribute('aria-hidden', 'true');
      document.body.appendChild(bar);
    }
    bar.classList.remove('is-on');
    void bar.offsetWidth;
    bar.classList.add('is-on');
  }
  function reset() {
    if (bar) bar.classList.remove('is-on');
    document.querySelectorAll('.lf-tap, .lf-press').forEach(function (el) { el.classList.remove('lf-tap', 'lf-press'); });
  }
  // Bubble-Phase auf window: laeuft nach den Theme-Skripten, abgefangene Klicks (Warenkorb-Schublade usw.) sind dann schon markiert
  window.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
    var u;
    try { u = new URL(a.href, location.href); } catch (err) { return; }
    if (u.origin !== location.origin) return;
    if (u.pathname === location.pathname && u.search === location.search) return; // nur Anker
    if (/^\/(cart|checkouts?)(\/|$)/.test(u.pathname)) return;
    var c = cardOf(a);
    if (c) c.classList.add('lf-tap');
    showBar();
  });
  window.addEventListener('pageshow', reset);
  window.addEventListener('pagehide', function () { setTimeout(reset, 0); });

  /* ---------- 3 · Lieferzeitleiste ---------- */
  var TZ = 'Europe/Berlin';
  function berlinNow() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { y: +p.year, m: +p.month - 1, d: +p.day, h: +p.hour, mi: +p.minute };
  }
  function day(y, m, d) { return new Date(Date.UTC(y, m, d)); }
  function isWork(dt) { var w = dt.getUTCDay(); return w !== 0 && w !== 6; }
  function plusDays(dt, n) { var x = new Date(dt.getTime()); x.setUTCDate(x.getUTCDate() + n); return x; }
  function nextWork(dt) { var x = plusDays(dt, 1); while (!isWork(x)) x = plusDays(x, 1); return x; }
  function addWork(dt, n) { var x = dt, c = 0; while (c < n) { x = plusDays(x, 1); if (isWork(x)) c++; } return x; }
  var MON = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dez.'];
  function range(a, b) {
    var da = a.getUTCDate(), db = b.getUTCDate(), ma = a.getUTCMonth(), mb = b.getUTCMonth();
    if (a.getTime() === b.getTime()) return db + '. ' + MON[mb];
    if (ma === mb) return da + '. – ' + db + '. ' + MON[mb];
    return da + '. ' + MON[ma] + ' – ' + db + '. ' + MON[mb];
  }
  function pair(s, def) {
    var p = String(s || def).split(',');
    var a = parseInt(p[0], 10), b = parseInt(p[1], 10);
    if (isNaN(a)) a = parseInt(def, 10);
    if (isNaN(b)) b = a;
    return [a, b];
  }
  // Bestelltag = heute (bis Annahmeschluss, 24 = Mitternacht), sonst morgen.
  // Versendet = Werktage nach dem Bestelltag (data-ship). Zugestellt = Kalendertage nach dem Versand (data-eta).
  function calc(orderDay, ship, del) {
    var s1 = addWork(orderDay, ship[0]), s2 = addWork(orderDay, ship[1]);
    return { s1: s1, s2: s2, d1: plusDays(s1, del[0]), d2: plusDays(s2, del[1]) };
  }
  function eta() {
    var els = document.querySelectorAll('.lf-eta3');
    if (!els.length) return;
    var n;
    try { n = berlinNow(); } catch (err) { return; }
    els.forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff'), 10);
      if (isNaN(cutoff)) cutoff = 24;
      var today = day(n.y, n.m, n.d);
      var orderDay = n.h < cutoff ? today : plusDays(today, 1);
      var ship = pair(el.getAttribute('data-ship'), '1,1');
      var del = pair(el.getAttribute('data-eta'), '1,3');
      var c = calc(orderDay, ship, del);
      var sTxt = range(c.s1, c.s2), dTxt = range(c.d1, c.d2);
      var sEl = el.querySelector('[data-k="ship"]');
      var dEl = el.querySelector('[data-k="del"]');
      if (sEl && sEl.textContent !== sTxt) sEl.textContent = sTxt;
      if (dEl && dEl.textContent !== dTxt) dEl.textContent = dTxt;

      // Countdown bis zum Annahmeschluss, nur wenn sich danach der Versandtag wirklich verschiebt
      var mins = Math.round((orderDay.getTime() - today.getTime()) / 60000) + cutoff * 60 - (n.h * 60 + n.mi);
      var later = calc(plusDays(orderDay, 1), ship, del);
      var shifts = later.s1.getTime() !== c.s1.getTime();
      var wrap = el.querySelector('[data-k="cdwrap"]');
      var cd = el.querySelector('[data-k="cd"]');
      if (wrap && cd) {
        if (shifts && mins > 0 && mins <= 24 * 60) {
          var h = Math.floor(mins / 60), m = mins % 60;
          var t = (h ? h + ' Std. ' : '') + m + ' Min.';
          if (cd.textContent !== t) cd.textContent = t;
          wrap.hidden = false;
        } else {
          wrap.hidden = true;
        }
      }
    });
  }

  function run() { eta(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setInterval(eta, 30000);
  var timer;
  function watch() {
    new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(eta, 60); })
      .observe(document.body, { childList: true, subtree: true });
  }
  if (document.body) watch(); else document.addEventListener('DOMContentLoaded', watch);
})();
